import getValidRedirectUrl from '@collab/utils/getValidRedirectUrl';

import protectedUrls from './protectedUrls';

const getNonProtectedUrl = (url: string): string =>
  getValidRedirectUrl(url, protectedUrls);

export { getNonProtectedUrl };
